(function () {
    'use strict';

    angular
        .module('app.associationAdmin')
        .constant('associationMemberComplianceReportResolver', {
            managementGroups: getManagementGroups,
            data: getMemberComplianceReport
        });

    getManagementGroups.$inject = ['$transition$', 'ManagementGroup'];
    function getManagementGroups($transition$, ManagementGroup) {
        return ManagementGroup.getManagementGroups(
            {
                includeAll: true,
            }, true).$promise;
    }

    getMemberComplianceReport.$inject = ['$transition$', 'ManagementGroup'];
    function getMemberComplianceReport($transition$, ManagementGroup) {
        return ManagementGroup.getMemberComplianceReport({
            $orderby: null,
            $skip: 0,
            $top: 50,
            $filter: { managementGroup: 0},
        }, true).$promise;
    }

})();